import angular = require("angular");

import "./Common/NavBar/NavBar";

class NotAllowedController {
	constructor() { }
}

angular.module('notAllowedApp', ['ui.bootstrap', 'directives'])
	.controller('notAllowedController', [() => new NotAllowedController()]);


// WEBPACK FOOTER //
// ./notAllowedApp.ts